import { TableGridBaseColDef } from '@components/table/types/TableColumnDef.type';
import { Box } from '@mui/material';
import { iconsByCardType } from '@pages/QuoteDetails/sidebarItems/SidebarCard';
import { Typography } from '@mui/material';
import { getDateFormatter } from '@utils/date';
import { format } from 'date-fns';
import { LongDateFormatWithoutSeconds } from '@utils/date';
import { OverflowTooltip } from '@components/tooltip/OverflowTooltip';
import { ClockFormat } from '@lio/rule-engine';
import { UnderwritingActivityItem } from '@models/underwritingReferral';

const iconStyle = { height: '20px', width: '20px', alignSelf: 'center' };

// FUTURE FULLSCREEN TODO: probably needs to show resolved reason and such, but should try to figure out how to make this table more dynamic/reusable from side summary to prevent these mass multi place updates
export const getUnderwritingActivityColumns = (
  handleEditClick: (activity: UnderwritingActivityItem) => void,
  clockFormat: ClockFormat,
): TableGridBaseColDef<UnderwritingActivityItem>[] => [
  {
    field: 'status',
    headerName: 'Status',
    width: 90,
    sortable: false,
    renderCell: ({ row }) => (
      <Box
        sx={{
          display: 'flex',
          alignContent: 'center',
          height: '100%',
          gap: 1,
          svg: {
            fill: (theme) =>
              theme.palette.theme === 'lio' ? theme.palette.success.dark : `${theme.palette.success.main} !important`,
          },
        }}
      >
        {row.resolvedByUser === null
          ? iconsByCardType(iconStyle).UnderwritingActivity.open
          : iconsByCardType(iconStyle).UnderwritingActivity.closed}

        <Typography variant='bodySmall' sx={{ alignSelf: 'center' }}>
          {row.resolvedByUser === null ? 'Open' : 'Closed'}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'createdAt',
    headerName: 'Start Date',
    width: 180,
    sortable: false,
    renderCell: ({ row }) => (
      <Typography variant='bodySmall'>
        {row.createdAt
          ? format(new Date(row.createdAt), getDateFormatter(clockFormat, LongDateFormatWithoutSeconds))
          : '-'}
      </Typography>
    ),
  },
  {
    field: 'type',
    headerName: 'Reason',
    sortable: false,
    width: 300,
    renderCell: ({ row }) => (
      <OverflowTooltip tooltipText={row.underwritingActivityType?.label || '-'}>
        <Typography variant='bodySmall' noWrap sx={{ maxWidth: 250, textOverflow: 'ellipsis', overflow: 'hidden' }}>
          {row.underwritingActivityType?.label || '-'}
        </Typography>
      </OverflowTooltip>
    ),
  },
  {
    field: 'description',
    headerName: 'Description',
    sortable: false,

    renderCell: ({ row }) => (
      <OverflowTooltip tooltipText={row.description || '-'}>
        <Typography variant='bodySmall' noWrap sx={{ maxWidth: 350, textOverflow: 'ellipsis', overflow: 'hidden' }}>
          {row.description || '-'}
        </Typography>
      </OverflowTooltip>
    ),
  },
  {
    field: 'resolutionNote',
    headerName: 'Note',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => (
      <OverflowTooltip tooltipText={row.note || '-'}>
        <Typography variant='bodySmall' noWrap sx={{ maxWidth: 350, textOverflow: 'ellipsis', overflow: 'hidden' }}>
          {row.note || '-'}
        </Typography>
      </OverflowTooltip>
    ),
  },
];
